document.addEventListener('DOMContentLoaded', function() {
  const currentUrl = window.location.href;
  const isProductPage = currentUrl.includes('/products/');
  const body = document.body;
  const isExcludedTemplate = body.classList.contains('template-product-one-size-round') || body.classList.contains('template-product-one-size-rectangular') || body.classList.contains('product-3d');  
    
  if (isProductPage && !isExcludedTemplate) {
    const referrer = document.referrer;
    const cameFromCollection = referrer && (
      referrer.includes('/collections/') || 
      referrer.includes('/collections?') ||
      referrer.includes('/collections&')
    );
    
    if (cameFromCollection) {
      document.body.classList.add('from-collection');
      productSettingsChoise()
    }
  }

  // document.body.classList.add('from-collection');
  // productSettingsChoise()
});


function productSettingsChoise() {
  const buttonAddToCart = document.querySelector('.add-to-cart');
  const buttonCommunication = document.querySelector('.communication__block_buttons .button');
  const drawetOptions = document.querySelectorAll('.hc-drawer-label-js');
  const drawerItems = document.querySelectorAll('.hc-drawer-val');
  const fromPrice = document.querySelector('.prodct__price_from');

  if (fromPrice) {
    if(fromPrice.classList.contains('price__from_hide')) {
      fromPrice.classList.remove('price__from_hide')
    }
  }
  

  if (buttonAddToCart) {
    buttonAddToCart.classList.add('btn_disabled');
  }
  if (buttonCommunication) {
    buttonCommunication.classList.add('btn_disabled_comm');    
  }

  drawetOptions.forEach((item) => {    
    item.classList.add('drawer__select_required');
  })  

  choiseText();

  document.addEventListener('click', function(e) {
    const button = e.target.closest('.btn_disabled');
    const buttonComm = e.target.closest('.btn_disabled_comm');

    if (button) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      selectOptions();

      selectOptions('add-to-cart');

      return false;
    }

    if (buttonComm) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      selectOptions('popup');

      return false;
    }

  }, true);

  drawerItems.forEach((option) => {
    if (option.classList.contains('hc-drawer-val-active')) {
      option.classList.remove('hc-drawer-val-active')
    }
  })

  function selectOptions(buttonType = 'all') {
    drawetOptions.forEach((item) => {
      if (item.classList.contains('drawer__select_required')) {      
        
        if (buttonType === 'popup') {
          const isSize = item.classList.contains('hc-drawer-width') || item.classList.contains('hc-drawer-length') || item.classList.contains('hc-drawer-diameter');
          
          if (!isSize) {
            const warningText = item.parentNode.querySelector('.hc-label__warning');
            item.classList.remove('drawer__select_warning');
            
            if (warningText && warningText.classList.contains('hc-label__warning_active')) {
              warningText.classList.remove('hc-label__warning_active');
            }
            return;
          }
        }
        
        const warningText = item.parentNode.querySelector('.hc-label__warning');
        item.classList.add('drawer__select_warning');

        if (warningText && !warningText.classList.contains('hc-label__warning_active')) {
          warningText.classList.add('hc-label__warning_active');
        }
      }      
    })
  }

  choiseOptions()
}

function choiseText() {
  const variantText = document.querySelectorAll('.variant__name_text');
  const variantOption = document.querySelectorAll('.variant__name_option');
  const colOption = document.querySelectorAll('.col-name')

  variantOption.forEach((option) => {
    if (!option.classList.contains('option_none')) {
      option.classList.add('option_none')
    }
  })  

  variantText.forEach((text) => {
    if (text.classList.contains('option_none')) {
      text.classList.remove('option_none')
    }
  })

  colOption.forEach((name) => {
    if (!name.classList.contains('option_none')) {
      name.classList.add('option_none')
    }
  })  
}

function choiseOptions() {
  function checkAllOptions() {
    const allOptions = document.querySelectorAll('.hc-drawer');
    const fromPrice = document.querySelector('.prodct__price_from');
    let allSelected = true;
    let sizeSelected = true;
    let sellectOptionPrice = true; 
    
    allOptions.forEach(container => {
      const requiredOption = container.querySelector('.drawer__select_required');

      if (requiredOption) {
        allSelected = false;

        if (requiredOption.classList.contains('hc-drawer-width') || requiredOption.classList.contains('hc-drawer-length') || requiredOption.classList.contains('hc-drawer-diameter')) {
          sizeSelected = false;
        }
      }

      if (!container.classList.contains('hc-drawer-color')) {
        if (requiredOption) {
          sellectOptionPrice = false;
        }
      }
    });    
    
    if (allSelected) {
      document.querySelectorAll('.add-to-cart').forEach(btn => {
        if (btn.classList.contains('btn_disabled')) {
          btn.classList.remove('btn_disabled');
        }        
      });
    } else {
      document.querySelectorAll('.add-to-cart').forEach(btn => {
        if (!btn.classList.contains('btn_disabled')) {
          btn.classList.add('btn_disabled');
        }
      });
    }

    if (sizeSelected) {
      document.querySelectorAll('.communication__block_buttons .button').forEach(btn => {
        if (btn.classList.contains('btn_disabled_comm')) {
          btn.classList.remove('btn_disabled_comm');
        }        
      });
    } else {
      document.querySelectorAll('.communication__block_buttons .button').forEach(btn => {
        if (!btn.classList.contains('btn_disabled_comm')) {
          btn.classList.add('btn_disabled_comm');
        }
      });
    }

    if(sellectOptionPrice) {
      if (fromPrice) {
        if(!fromPrice.classList.contains('price__from_hide')) {
          fromPrice.classList.add('price__from_hide')
        }
      }
    } else {
      if (fromPrice) {
        if(fromPrice.classList.contains('price__from_hide')) {
          fromPrice.classList.remove('price__from_hide')
        }
      }
    }
  }

  document.addEventListener('click', function(e) {
    const optionsContainer = e.target.closest('.hc-drawer-val');    
    
    if (optionsContainer) {
      setTimeout(checkAllOptions, 10);
    }
  });
  
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        checkAllOptions();
      }
    });
  });
  
  document.querySelectorAll('[data-js-product-variant-container]').forEach(el => {
    observer.observe(el, { attributes: true, attributeFilter: ['class'] });
  });
  
  checkAllOptions();
}